var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconThumbUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#acc911;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_17",
    "data-name": "Gruppe 17"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    className: "cls-1",
    cx: 60,
    cy: 60,
    r: 60
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-thumb-up",
    "data-name": "Icon material-thumb-up",
    className: "cls-2",
    d: "M24.1,92H37.7V51.2H24.1ZM98.9,54.6a6.82,6.82,0,0,0-6.8-6.8H70.65l3.23-15.54.1-1.09a5.17,5.17,0,0,0-1.5-3.6L68.88,24,46.51,46.41a6.61,6.61,0,0,0-2,4.79v34A6.82,6.82,0,0,0,51.3,92H81.9a6.77,6.77,0,0,0,6.26-4.15l10.26-24a6.59,6.59,0,0,0,.48-2.48V54.91l0,0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbUp);
export default __webpack_public_path__ + "static/media/icon_thumb_up.dc82a211fe48876460749a5cbc65cad4.svg";
export { ForwardRef as ReactComponent };